import './I18nextText.scss';

import React from 'react';

import { Trans } from 'react-i18next';

import type { TranslationKeysType } from '../../typedef/i18next';

const createDefaultComponents = () => ({
  br: <br />,
  strong: <span className="bold" />,
  underline: <span className="underline" />,
  regularText: <span className="regular" />,
});

type Props = React.HTMLAttributes<HTMLDivElement> & {
  components?: Record<string, React.ReactNode>;
  i18nKey: TranslationKeysType;
  values?: Record<string, unknown>;
  testid?: string;
};
export const I18Text: React.FC<Props> = ({ components, i18nKey, values, testid, ...props }) => {
  return (
    <p {...props} data-testid={testid}>
      <Trans components={{ ...createDefaultComponents(), ...components }} i18nKey={i18nKey} values={values} />
    </p>
  );
};
